import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles, Collapse, Divider } from '@material-ui/core';

import { AnimatedProgress, Button } from '../../../../components';

const ROW_STEP_SIZE = 20;

const styles = {
  button: {
    width: '100%',
    marginBottom: '10px',
  },
  groupHeader: {
    cursor: 'pointer',
    paddingBottom: '10px',
    '&:hover': {
      background: '#f9f9f9',
    },
  },
  itemHeader: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  bar: {
    background: '#e7e5e6',
    height: '25px',
  },
  thresholdBar: {
    backgroundImage: 'linear-gradient(to right, #C00000, #AFCB1F)',
  },
  divider: {
    margin: '10px 0 15px',
  },
  thresholdIndicator: {
    height: '25px',
    position: 'absolute',
    border: '2px solid black',
    left: '50%',
    zIndex: 2,
  },
};

const ThresholdItem = ({ classes, value }) => {
  const {
    Artikelname, Menge, MaxBestand, Schwellwert, Grundeinheit,
  } = value;

  const progress = Menge / MaxBestand * 100;
  const thresholdLeft = Math.max(0, Schwellwert / MaxBestand * 100);

  return (
    <div>
      <div className={classes.itemHeader}>
        <div>
          {Artikelname}
        </div>
        <div>
          {`${Menge}/${MaxBestand} ${Grundeinheit}`}
        </div>
      </div>
      <div style={{ position: 'relative' }}>
        <div style={{ ...styles.thresholdIndicator, left: `${thresholdLeft}%` }} />
        <AnimatedProgress
          variant="determinate"
          value={Number.isFinite(progress) ? progress : 0}
          className={classes.bar}
          classes={{ barColorPrimary: classes.thresholdBar }}
        />
      </div>
      <div style={{ paddingLeft: `${thresholdLeft}%` }}>
        <span>{Schwellwert}</span>
      </div>

      <Divider className={classes.divider} />
    </div>
  );
};

ThresholdItem.propTypes = {
  classes: PropTypes.object.isRequired,
  value: PropTypes.object.isRequired,
};

const ThresholdGroup = ({
  name, values, classes, showThresholdOnly,
}) => {
  const [isCollapsed, setCollapsed] = useState(true);
  const [nrRowsShown, setNrRowsShown] = useState(ROW_STEP_SIZE);

  let selectedValues = showThresholdOnly ? values.filter(v => v.Schwellwert) : values;
  const moreRowsAvailable = selectedValues.length > nrRowsShown;

  selectedValues = selectedValues.slice(0, nrRowsShown);

  const thresholdItems = selectedValues.map(value => <ThresholdItem key={value.Artikelname} classes={classes} value={value} />);

  return (
    <div>
      <div
        className={classes.groupHeader}
        onClick={() => setCollapsed(!isCollapsed)}
        onKeyDown={() => setCollapsed(!isCollapsed)}
      >
        <h3>{name}</h3>
      </div>
      <Collapse in={!isCollapsed}>
        {thresholdItems}
        {nrRowsShown > ROW_STEP_SIZE && (
          <Button
            style={styles.button}
            onClick={() => setNrRowsShown(nrRowsShown - ROW_STEP_SIZE)}
          >
            Weniger anzeigen
          </Button>
        )}
        {moreRowsAvailable
        && (
          <Button
            style={styles.button}
            onClick={() => setNrRowsShown(nrRowsShown + ROW_STEP_SIZE)}
          >
            Mehr anzeigen
          </Button>
        )
        }
      </Collapse>
    </div>
  );
};

ThresholdGroup.propTypes = {
  classes: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  values: PropTypes.array.isRequired,
  showThresholdOnly: PropTypes.bool,
};

ThresholdGroup.defaultProps = {
  showThresholdOnly: false,
};

export default withStyles(styles)(ThresholdGroup);
